import React from 'react';
import '../styles/game-link.css';
import itchIcon from "../assets/img/itchio-textless-white.svg";
import { SportsEsports, GitHub, RocketLaunch } from "@mui/icons-material";
import { Col } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

interface GameLinkProps {
    data: Array<{ type: 'text' | 'itchio' | 'github' | 'overall'; url: string; overrideUrl?: string; text?: string }>;
    gameName: string;
    isSelfLink?: boolean;
    overrideTitle?: string;
    overrideCta?: string;
}

function GameLink({ data, gameName, isSelfLink = false, overrideTitle, overrideCta }: GameLinkProps) {
    const isMobile = useMediaQuery({ minWidth: 537 });

    const renderContent = (item: { type: 'text' | 'itchio' | 'github' | 'overall'; url: string; overrideUrl?: string; text?: string }) => {
        let icon: JSX.Element | null = null;
        let defaultText;
        switch (item.type) {
            case 'overall':
                icon = <RocketLaunch />;
                defaultText = overrideCta != null ? overrideCta : "Play now: " + gameName;
                break;
            case 'text':
                icon = <SportsEsports />;
                defaultText = overrideCta != null ? overrideCta : "Play now: " + gameName;
                break;
            case 'itchio':
                icon = <img src={itchIcon} alt="Itch.io" />;
                defaultText = "View on Itch.io";
                break;
            case 'github':
                icon = <GitHub />;
                defaultText = "Explore the Source Code";
                break;
            default:
                return null;
        }

        return <a href={item.url} className={`contact-banner`} target={isSelfLink ? "" : "_blank" } rel="noreferrer">
            <div className="contact-banner-icon" style={{padding: "1vw"}}>
                {icon}
            </div>

            <div className="contact-banner-text">
                <p>{item.text != null ? item.text : defaultText}</p>
                {isMobile && (<p className="contact-banner-link" style={{ marginTop: ".4rem" }}>{item.overrideUrl ?
                    item.overrideUrl : item.url.replace("https://", "").replace("www.", "")}</p>)}
            </div>
        </a>;
    };

    return (
        <>
            <h1 className="a-subtitle">{overrideTitle != null ? overrideTitle : "Links"}</h1>
            <Col size={12} lg={12} md={12} sm={12} className="contact-links-col">
                {data.map((item, index) => (
                    <React.Fragment key={index}>
                        {renderContent(item)}
                    </React.Fragment>
                ))}
            </Col>
        </>
    );
}

export default GameLink;
